import PropTypes from 'prop-types';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import cx from 'classnames';
import { green700, grey200 } from 'material-ui/styles/colors';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
const config = __RLZ_CONFIG__;

class ThemesList extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            themes: [],
            themeCreationIsOpen: false,
            defaultTheme: context.user.defaultTheme,
            newThemeName: '',
            newThemeDescription: '',
            themeCreationInProgress: false,
            themeCreationFailed: false,
            themeCreationSucceed: false,
            showHidden: this.props.route.params.isHidden || false
        };

        this.loadData();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    loadData = additionalStateParams => {
        var user = this.context.user;

        if (!user || !user.client) return null;
        const token = auth.getAccessToken();
        return fetch(`${config.dash.api.host}/api/themes?access_token=${token}`)
            .then(response => response.json())
            .then(themes => {
                this.setState({
                    themes,
                    isLoading: false,
                    ...additionalStateParams
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    error: e,
                    isLoading: false,
                    ...additionalStateParams
                });
            });
    };

    updateThemeById = (id, update = {}, isPromise) => {
        let _themes = _.cloneDeep(this.state.themes).map(theme => {
            if (theme.id === id) {
                theme = { ...theme, ...update };
            }
            return theme;
        });

        if (isPromise) {
            return new Promise(resolve => {
                this.setState({ themes: _themes }, () => resolve());
            });
        } else {
            this.setState({ themes: _themes });
        }
    };

    handleThemeCreationOpen = e => {
        e.preventDefault();
        this.setState({ themeCreationIsOpen: true });
    };

    handleThemeCreationClose = e => {
        e.preventDefault();
        this.setState({ themeCreationIsOpen: false });
    };

    handleNewThemeNameChange = e => {
        this.setState({
            newThemeName: e.target.value
        });
    };

    handleNewThemeDescriptionChange = e => {
        this.setState({
            newThemeDescription: e.target.value
        });
    };

    handleThemeHide = (id, isHidden) => {
        id = encodeURIComponent(id);

        this.updateThemeById(id, { isInteractingWithApi: true });

        const { _id: userId } = this.context.user;
        fetch(`${config.dash.api.host}/api/themes/${id}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                isHidden: !isHidden
            })
        }).then(response => {
            let { status } = response;

            if (status === 200) {
                this.updateThemeById(id, { isInteractingWithApi: false, isHiddenInUI: !isHidden });
                return response.json();
            }
        });
    };

    handleThemeDefault = id => {
        const { _id: userId } = this.context.user;

        return fetch(`${config.dash.api.host}/api/users/${userId}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ defaultTheme: id })
        })
            .then(response => response.json())
            .then(() => {
                auth.saveUser({ ...this.context.user, defaultTheme: id });
                this.setState({
                    defaultTheme: id
                });
            })
            .catch(e => console.log(e));

        return this.updateThemeById(id, { isInteractingWithApi: true }, true).then(() => {
            return fetch(`${config.dash.api.host}/api/themes/reset-default-theme`)
                .then(response => response.json())
                .then(() => {
                    return fetch(`${config.dash.api.host}/api/users/${userId}?access_token=${auth.getAccessToken()}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            isDefault: true
                        })
                    });
                })
                .then(response => {
                    let { status } = response;

                    if (status === 200) {
                        this.updateThemeById(_.find(this.state.themes, t => t.isDefault).id, { isDefault: false }, true).then(() =>
                            this.updateThemeById(
                                id,
                                {
                                    isInteractingWithApi: false,
                                    isDefault: true
                                },
                                true
                            ).then(() => response.json())
                        );
                    }
                });
        });
    };

    handleThemeCreationSubmit = e => {
        e.preventDefault();
        const { newThemeName: themeName, newThemeDescription: themeDescription } = this.state;
        this.setState({ themeCreationInProgress: true, themeCreationIsOpen: false, newThemeName: '', newThemeDescription: '' });

        // const themeIdFromName = encodeURIComponent(_.kebabCase(this.state.newThemeName));

        fetch(`${config.dash.api.host}/api/themes/create-theme?access_token=${auth.getAccessToken()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ themeName, themeDescription })
        })
            .then(response => response.json())
            .then(info => {
                console.log('AFTER SOME RESPONSE', +new Date());
                return this.loadData({ themeCreationSucceed: true, themeCreationInProgress: false });
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    themeCreationInProgress: false,
                    themeCreationFailed: true
                });
            });
    };

    render() {
        let { themes } = this.state;

        const actions = [
            <rmd.FlatButton label="Cancel" primary onTouchTap={this.handleThemeCreationClose} />,
            <rmd.FlatButton label="Submit" primary disabled={!this.state.newThemeName} onTouchTap={this.handleThemeCreationSubmit} />
        ];

        const hiddenThemesExist = themes.some(t => t.isHidden);
        const hiddenFilterLabel = this.state.showHidden ? 'Show active themes' : 'Show hidden themes';
        const noThemes = _.isEmpty(themes);

        themes = _.sortBy(themes, t => {
            if (t.id === this.state.defaultTheme) return -Infinity;
            else return new Date(t.createdAt);
        });

        const mainThemeColors = ['bg-color', 'gray-base', 'primary-color', 'primary-text-color', 'home-color', 'away-color'];

        return (
            <div className="pick-theme">
                <div className="row">
                    <div className="col-xs-6">
                        {!noThemes &&
                            <rmd.Subheader>
                                Choose existing theme or create new
                                {/*<a href="#" onClick={this.handleThemeCreationOpen}> create new</a>*/}
                            </rmd.Subheader>}
                        {noThemes &&
                            <rmd.Subheader>
                                Create your first theme!
                                {/*<a href="#" onClick={this.handleThemeCreationOpen}>Create your first theme!</a>*/}
                            </rmd.Subheader>}
                    </div>
                    <div className="col-xs-6" style={{ textAlign: 'right' }}>
                        {!noThemes &&
                            hiddenThemesExist &&
                            <rmd.Subheader>
                                <Link href={this.state.showHidden ? '/themes' : '/themes/hidden'}>{hiddenFilterLabel}</Link>
                            </rmd.Subheader>}
                    </div>
                </div>

                <rmd.Dialog title="New theme creation" actions={actions} onRequestClose={this.handleThemeCreationClose} open={this.state.themeCreationIsOpen}>
                    <rmd.TextField floatingLabelText="Theme name (unique) *" value={this.state.newThemeName} autoFocus onChange={this.handleNewThemeNameChange} />
                    <br />
                    <rmd.TextField floatingLabelText="Theme description" multiLine rows={1} rowsMax={2} onChange={this.handleNewThemeDescriptionChange} />
                </rmd.Dialog>

                <div className="row">
                    <ReactCSSTransitionGroup transitionName="rlzFadeAnimation" transitionEnterTimeout={500} transitionLeave={false}>
                        {themes.filter(t => (this.state.showHidden ? t.isHidden : !t.isHidden)).map((theme, i) => {
                            let hideActionLabel = 'Hide';

                            if (theme.isHidden) hideActionLabel = 'Show';
                            if (theme.isHiddenInUI) hideActionLabel = 'Show';
                            if (theme.isHiddenInUI === false) hideActionLabel = 'Hide';

                            let themeIsDefault = theme.id === this.state.defaultTheme;

                            return (
                                <div className="col-xs-12 col-sm-6 col-md-4" key={theme.id}>
                                    <div className="theme-template-wrapper">
                                        <rmd.Card className="theme-template">
                                            <div className={`theme__theme-colors widget-img`}>
                                                {mainThemeColors.map(colorName => {
                                                    let backgroundColor = theme.userVariables[colorName];
                                                    if (backgroundColor && backgroundColor.indexOf('$') !== -1) backgroundColor = theme.userVariables[backgroundColor.substr(1)];
                                                    return (
                                                        <div className="theme__theme-color" key={colorName} style={{ background: backgroundColor, color: backgroundColor }}>
                                                            <span className="theme__theme-color-name">{colorName}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/*<rmd.CardMedia
                                                className={`widget-img wdp wdp_${theme.id}`}
                                                overlay={mainThemeColors.map(colorName => {
                                                    return (
                                                        <div style={{float: 'left', width: '33%', height: '50%'}} className={`bg-${colorName}`}></div>
                                                    )
                                                })}
                                            />*/}
                                            <rmd.CardText>
                                                <span className="theme__theme-name">{theme.name}</span>
                                                <span style={{ color: '#b2b2b2' }}>{theme.description.length ? theme.description : 'No description'}</span>
                                            </rmd.CardText>
                                            <rmd.CardActions className="actions">
                                                {!themeIsDefault &&
                                                    <rmd.FlatButton
                                                        onClick={e => this.handleThemeHide(theme.id, theme.isHiddenInUI !== undefined ? theme.isHiddenInUI : theme.isHidden)}
                                                        disabled={theme.isInteractingWithApi}
                                                        className="hide"
                                                        label={hideActionLabel}
                                                    />}
                                                {!themeIsDefault &&
                                                    !theme.isHidden &&
                                                    !theme.isHiddenInUI &&
                                                    <rmd.FlatButton
                                                        onClick={e => this.handleThemeDefault(theme.id)}
                                                        disabled={theme.isInteractingWithApi}
                                                        className="default"
                                                        secondary
                                                        label={'Make default'}
                                                    />}
                                                {themeIsDefault &&
                                                    <rmd.Chip style={{ float: 'left' }}>
                                                        <rmd.Avatar backgroundColor={grey200} color={green700} icon={<CheckIcon />} />
                                                        Default theme
                                                    </rmd.Chip>}
                                                <Link to={`/themes/${theme.id}/customize`}>
                                                    <rmd.FlatButton className="create" label="Edit" primary />
                                                </Link>
                                            </rmd.CardActions>
                                        </rmd.Card>
                                    </div>
                                </div>
                            );
                        })}
                        {!this.state.showHidden &&
                            <div className="col-xs-12 col-sm-6 col-md-4" key="create-theme">
                                <div
                                    className={cx('create-theme-card', { creating: this.state.themeCreationInProgress })}
                                    onClick={this.state.themeCreationInProgress ? () => {} : this.handleThemeCreationOpen}
                                >
                                    {this.state.themeCreationInProgress ? <Autorenew /> : <ContentAdd />}
                                </div>
                            </div>}
                    </ReactCSSTransitionGroup>
                </div>

                <rmd.Snackbar
                    open={this.state.themeCreationSucceed}
                    message={`Theme was successfully created.`}
                    autoHideDuration={5000}
                    onRequestClose={() => this.setState({ themeCreationSucceed: false })}
                />
                <rmd.Snackbar
                    open={this.state.themeCreationFailed}
                    message={`Error. Could not create theme. Try again.`}
                    autoHideDuration={5000}
                    bodyStyle={{ backgroundColor: 'rgba(198,40,40,0.8)' }}
                    onRequestClose={() => this.setState({ themeCreationFailed: false })}
                />
            </div>
        );
    }
}

export default ThemesList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ThemesList.js
 **/